<ng-container *ngIf="mode === 'ReadOnly'; then read; else edit"></ng-container>
<ng-template #read>

    <entity-item [entity]="$safeNavigationMigration(control?.value)"></entity-item>

</ng-template>
<ng-template #edit>

    <ng-select groupBy="groupType" [searchFn]="searchFn" [items]="$data()" [placeholder]="placeholder" [searchable]="true" [formControl]="control" [multiple]="multiple">
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of items">
                <entity-item (clear)="clear(item)" [clearTemplate]="true" [entity]="item"></entity-item>
            </div>
        </ng-template>
        <ng-template ng-label-tmp let-item="item" let-index="index">
            <entity-item [entity]="item"></entity-item>
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-index="index">
            <entity-item [entity]="item"></entity-item>
        </ng-template>
    </ng-select>

</ng-template>


<ng-template #emptyField>
    <span class="empty-field">{{ emptyText }}</span>
</ng-template>